import type { ReactNode } from 'react';
import { getServiceLabel } from '@common/customControls/getServiceLabel';
import { getDisplayName } from '@common/utils/getDisplayName';
import { translateKey } from '@frontend/translate';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';
import type { IRequest } from '../../../../elements/getStatusLabel';
import type { IDiagnosticReportGetOne } from '../../../../interfaces/diagnosticReportGetOne';
import type { IServiceGetOne } from '../../../../interfaces/serviceGetOne';
import type { IItemState } from '../../../episodes/Episode';
import { EditProcessContainer, ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';

interface INewOrEditDiagnosticReportProcessContainerProps {
    children: ReactNode;
    currentDiagnosticReport: IDiagnosticReportGetOne | undefined;
    dontShowPractitionerName?: boolean;
    itemState?: IItemState;
    process?: IRequest;
    service: IServiceGetOne;
    title?: string;
}

export function NewOrEditDiagnosticReportProcessContainer(props: INewOrEditDiagnosticReportProcessContainerProps) {
    const { frontendSettings } = useFrontendSettings();
    const commonProcessItemHeaderProps = {
        isFirstItem: false,
        isItemOpen: true,
        process: undefined,
        showProcessIcon: true,
    };

    if (!props.currentDiagnosticReport || !props.currentDiagnosticReport.id || props.dontShowPractitionerName) {
        return (
            <EditProcessContainer
                experimentalCarepathOphthalmologyEnabled={frontendSettings.experimentalCarepathOphthalmologyEnabled}
                isActiveActivity={props.itemState?.initialIsOpen}
            >
                <ProcessItemHeader
                    {...commonProcessItemHeaderProps}
                    title={
                        props.title ||
                        getServiceLabel(
                            props.service.code,
                            'diagnosticReport',
                            translateKey('diagnosticReport.category_examinationReport')
                        )
                    }
                />
                {props.children}
            </EditProcessContainer>
        );
    } else {
        return (
            <ProcessContainer isActiveActivity={props.itemState?.initialIsOpen}>
                <ProcessItemHeader
                    {...commonProcessItemHeaderProps}
                    organizationName={props.currentDiagnosticReport?.performerOrganization?.name}
                    practitionerName={
                        props.currentDiagnosticReport && props.currentDiagnosticReport.performerPractitioner
                            ? getDisplayName(props.currentDiagnosticReport.performerPractitioner)
                            : undefined
                    }
                    title={getServiceLabel(
                        props.service.code,
                        'diagnosticReport',
                        translateKey('diagnosticReport.category_examinationReport')
                    )}
                />
                {props.children}
            </ProcessContainer>
        );
    }
}
